export default {
  label: 'Etiquetas',
  placeholder: 'Todos',
};
